module.exports = __webpack_public_path__ + "img/index_title.e60fc8be.png";